<template>
  <div class="my-header">
    <a
      class="my-header__logo"
      href="https://www.zichanxinxi.com/"
      target="_self"
    >
    </a>
    <div class="my-header__routers">
      <ul>
        <li><a href="https://www.zichanxinxi.com/">首页</a></li>
        <li><a href="https://www.zichanxinxi.com/sale/">房地产</a></li>
        <li><a href="https://www.zichanxinxi.com/estate/">股权债权</a></li>
        <li><a href="https://www.zichanxinxi.com/house/">楼盘交易</a></li>
        <li><a href="https://www.zichanxinxi.com/vehicle/">交通工具</a></li>
        <li><a href="https://www.zichanxinxi.com/news/">行研策略</a></li>
        <li><a href="/map">地图选房</a></li>
        <li><a href="/api/assessment.php">房屋分析报告</a></li>
        <li><a href="https://www.zichanxinxi.com/tool">工具</a></li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: "Navigator",
  setup() {},
};
</script>
<style lang="less">
.my-header {
  width: 100%;
  min-width: 1150px;
  background-color: #2665a0;
  height: 62px;
  .my-header__logo {
    background-image: url(/staticys/images/nav-logo.png);
    background-repeat: no-repeat;
    height: 100%;
    width: 200px;
    float: left;
  }
  .my-header__routers {
    height: 100%;
    float: right;
    ul {
      padding-right: 15px;
      margin: 0;
      height: 100%;
      li {
        height: 100%;
        line-height: 62px;
        width: fit-content;
        margin-left: 20px;
        list-style: none;
        float: left;
        a {
          text-shadow: 0 0 5px rgb(0 0 0 / 30%);
          font-size: 16px;
          font-weight: 700;
          color: #fff;
          text-decoration: none;
        }
      }
    }
  }
  @media (max-width: 768px) {
    display: none;
  }
}
</style>
